import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Password Never Expires field definition
 * Boolean field with Yes/No dropdown for password never expires status filtering
 */
export const ADObjectPasswordNeverExpires = createBooleanSimpleFilterDefinition(
  'pwdneverexpires',
  'Password Never Expires'
);
